/**
 * Generated file, do not edit directly!
 */

/** Easings define the rate of change of an animation over time, affecting speed, acceleration, and deceleration. */

const Decelerate = 'var(--dt-easings-decelerate, cubic-bezier(0, 0, 0.2, 1))';
const Accelerate = 'var(--dt-easings-accelerate, cubic-bezier(0.5, 0, 1, 1))';
const SlowInFastOut =
  'var(--dt-easings-slow-in-fast-out, cubic-bezier(0.8, 0, 0.5, 1))';
const FastInSlowOut =
  'var(--dt-easings-fast-in-slow-out, cubic-bezier(0.4, 0, 0.2, 1))';
const OutBack = 'var(--dt-easings-out-back, cubic-bezier(0.4, 1.6, 0.7, 1))';
const RotateElastic =
  'var(--dt-easings-rotate-elastic, cubic-bezier(0.8, 0.3, 0.3, 0.8))';
export default {
  /**
   * Use to convey the deceleration of an object, such as when it's coming to a stop. It starts at a fast pace and then slows down at the end.
   * Css custom property: --dt-easings-decelerate. Value: cubic-bezier(0, 0, 0.2, 1).
   */
  Decelerate,
  /**
   * Use to convey the acceleration of an object, such as when it's being launched. It starts at a slow pace and then speeds up at the end.
   * Css custom property: --dt-easings-accelerate. Value: cubic-bezier(0.5, 0, 1, 1).
   */
  Accelerate,
  /**
   * Use to draw attention to an object. It starts slowly, accelerates in the middle, and then slows down again at the end.
   * Css custom property: --dt-easings-slow-in-fast-out. Value: cubic-bezier(0.8, 0, 0.5, 1).
   */
  SlowInFastOut,
  /**
   * Use to move or scale objects. It starts slowly, quickly accelerates in the middle, and slows down at the end.
   * Css custom property: --dt-easings-fast-in-slow-out. Value: cubic-bezier(0.4, 0, 0.2, 1).
   */
  FastInSlowOut,
  /**
   * Use to convey a playful or elastic effect, such as when an object bounces or stretches. It overshoots its target position before settling back into place.
   * Css custom property: --dt-easings-out-back. Value: cubic-bezier(0.4, 1.6, 0.7, 1).
   */
  OutBack,
  /**
   * Use to create dynamic, nonlinear rotation that adds energy and movement, ideal for rotating loading indicators.
   * Css custom property: --dt-easings-rotate-elastic. Value: cubic-bezier(0.8, 0.3, 0.3, 0.8).
   */
  RotateElastic,
};
